export const SET_RECEIPT_ATTACHMENT_IDS =
  'app/updateVirtualCardForm/SET_RECEIPT_ATTACHMENT_IDS'
export interface SetReceiptAttachmentIdsAction {
  type: typeof SET_RECEIPT_ATTACHMENT_IDS
  payload: {
    ids: string[]
  }
}
export const createSetReceiptAttachmentIds = (
  ids: string[],
): SetReceiptAttachmentIdsAction => ({
  type: SET_RECEIPT_ATTACHMENT_IDS,
  payload: {
    ids,
  },
})
